export default function ({ store, redirect }) {
  // If the store is not selected
  if (!store.state.data.currentStore) {
    return redirect('/stores')
  }
}
